// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"9367259a","453":"a35e8f6a"}[chunkId] + ".chunk.js";
};